import { AdresseModel } from './adresse.model';
import { LoyerModel } from './loyer.model';
import { PretListModel } from './pretList.model';

/**
 * Adresse du logement
 */
export class LogementModel {
    /**
     * lieu residence 
     */
    cdTypeLogement: string; 
    flgMeubleLogement: boolean;
    flgLogementConventionne: boolean;

    /**
     rempli uniquement cdTypeLogement = logement crous
     */
    typeLocal: string | undefined;

    adresse: AdresseModel;
    loyer: LoyerModel;

    pretList : PretListModel[] | null;
}
